import axios from 'axios';

const $apiRegion = axios.create({
    baseURL: 'https://region.qiosfin.com/api',
    headers: {
        'Content-Type': 'application/json',
    },
});

export default $apiRegion;
